import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const itemSummaryStatusBarStyleId = 'wb-work-job-item-summary-status-bar-theme';

export const itemSummaryStatusBarBridgeStyles = {
  '.ag-status-bar:has(item-summary-status-bar), item-summary-status-bar': {
    '--local-item-summary-bg': tokens.color.background.primary,
    '--local-item-summary-edge': tokens.color.border.secondary,
    '--local-item-summary-edge-width': tokens.borderWidth.sm,
    '--local-item-summary-label': tokens.color.text.tertiary,
    '--local-item-summary-value': tokens.color.text.primary,
    '--local-item-summary-positive': tokens.color.text.successPrimary,
    '--local-item-summary-negative': tokens.color.text.errorPrimary,
    '--local-item-summary-bar-padding-block': tokens.spacing.lg,
    '--local-item-summary-bar-padding-inline': tokens.spacing.xl,
    '--local-item-summary-field-padding-inline': tokens.spacing.twoXl,
    '--local-item-summary-field-gap': tokens.spacing.xl,
    '--local-item-summary-value-gap': tokens.spacing.xxs,
    '--local-item-summary-label-size': tokens.font.size.textSm,
    '--local-item-summary-label-line-height': tokens.lineHeight.textSm,
    '--local-item-summary-value-size': tokens.font.size.textMdBase,
    '--local-item-summary-value-line-height': tokens.lineHeight.textMd,
    // Numeric, not tokens.font.weight.medium: that token resolves to the Figma style name
    // ('Medium'), which is not a legal CSS font-weight and gets dropped. Board table and header
    // write the number for the same reason.
    '--local-item-summary-value-weight': '500',
  },
};
